"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
function CarouselBullet(_a) {
    var index = _a.index, BaseBullet = _a.bullet, setSlide = _a.setSlide, activeIndex = _a.activeIndex, style = _a.style, className = _a.className;
    function updateSlide() {
        setSlide(index);
    }
    if (BaseBullet)
        return (react_1.default.createElement(BaseBullet, { key: index, isActive: index === activeIndex, onClick: updateSlide }));
    return (react_1.default.createElement(styles_1.MainContainer, { key: index, active: index === activeIndex, onClick: updateSlide, style: style, className: className }));
}
exports.default = CarouselBullet;
//# sourceMappingURL=index.js.map